export const actionsStruct = {
  header: {
    style: {
      position: 'sticky',
      top: -16,
      zIndex: 1000,
      backgroundColor: "#f5f5f5",
      borderBottom: "1px solid #f0f0f0"
    }
  },
  actionSection: {
    gap: "8px",
    justify: "flex-end",
    wrap: "wrap"
  },

  actionButtonNext: {
    type: "primary"
  },

  actionButtonPrev: {
    type: "primary",
    ghost: true
  },
};
